import * as React from "react";
import { useConfig } from "../../utils/context/configContext";

/** Lightweight classnames helper to avoid depending on ../../utils/utils */
const cn = (...classes: Array<string | false | null | undefined>) =>
    classes.filter(Boolean).join(" ");

export interface CustomInputProps
    extends React.InputHTMLAttributes<HTMLInputElement> {
    className?: string;
    type?: string;
}

const CustomInput = React.forwardRef<HTMLInputElement, CustomInputProps>(
        ({ className, type, ...props }, ref) => {
            const config = useConfig();
            const input = config?.style?.input;
            const priority = input?.priority;
            return (
            <>
                <input
                    type={type}
                    className={`${className ? className : ''} customInput ` + cn(
                        "flex w-full  px-[.75rem]  h-[40px] text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed  backdrop-blur-sm bg-btn font-medium pl-[1rem] pr-[2.5rem]  focus:ring-1  focus:outline-none transition-all duration-200",
                    )}
                    autoCapitalize="off"
                    autoCorrect="off"
                    ref={ref}
                    {...props}
                    style={{
                        background: priority?.inputBackgroundColor || input?.inputBackgroundColor || '#F9FAFC',
                        color: priority?.inputTextColor || input?.inputTextColor || '#000',
                        fontSize: input?.inputFontSize || '16px',
                        fontWeight: input?.inputFontWeight || '400',
                        border: `1px solid ${input?.inputBorderColor || 'transparent'}`,
                        fontFamily: config?.style?.base?.baseFontFamily || 'Inter, sans-serif',
                        borderRadius: input?.inputBorderRadius || '4px',
                    }}
                />
                <style>
                    {`
            .customInput::placeholder {
              color: ${priority?.inputPlaceholderColor || input?.inputPlaceholderColor || '#000'};
              font-weight: ${input?.inputFontWeight || '500'};
              opacity: 1;
              font-size: ${input?.inputFontSize || '14px'};
                    }
            .customInput:focus-visible {
            box-shadow:0 0 0 2px white, 0 0 0 4px rgb(from currentColor r g b / 0.5);
          }

          `}
                </style>
            </>
        )}
    );

CustomInput.displayName = "CustomInput";

export default CustomInput;
